import { useEffect } from 'react';
import { IParameterDescription } from '../../models/IOperationDescriptions';
import { IParameterSettings } from '../../models/IParameterSettings';
import { MmgParameterInputSelect } from './parameter-input-select';
import WorkspaceGeometrySelectors from '../../store/selectors/WorkspaceGeometrySelectors';
import { useSelector } from 'react-redux';
import { IWorkspaceGeometry } from '../../models/IGeometries';
import { useAllowedDataItemsAsSelectValues } from './useAllowedDataItemsAsSelectValues';
import MikeVisualizerLib from '../../MikeVisualizer/lib/MikeVisualizer';
const { showElement, hideElements } = MikeVisualizerLib;

type ParameterGeometrySelectProps = {
  parameterKey: string;
  parameterDescription: IParameterDescription;
  name: string;
  value: string;
  label: string;
  placeholder: string;
  infoText?: string;
  helperText?: string;
  error?: boolean;
  customSettings?: IParameterSettings;
  onParameterChanged?: (param: string, val: string) => void;
};

/**
 * @name MmgConnectedParameterGeometrySelect
 * @param props
 * @summary A generic element that renders a select parameter for geometries and accepts a callback for when it change.
 *
 * The 'allowedValues' of the parameterDescription holds geoemtry ids and will be used for the select options
 *
 *
 */
export const MmgConnectedParameterGeometrySelect = (props: ParameterGeometrySelectProps) => {
  const { parameterDescription, value, ...rest } = props;
  const workspaceGeometries: Array<IWorkspaceGeometry> = useSelector(WorkspaceGeometrySelectors.getWorkspaceGeometries);

  const { parameterDescriptionWithValues, getValueDisplayName } = useAllowedDataItemsAsSelectValues(
    parameterDescription,
    workspaceGeometries,
  );

  useEffect(
    () => {
      // Show selected geometry when there is a selected value:
      hideElements(parameterDescription.allowedValues);
      value && showElement(value);
      return () => {
        // hide geometries when unmounting:
        hideElements(parameterDescription.allowedValues);
      };
    },
    [value, parameterDescription.allowedValues],
  );

  return (
    <MmgParameterInputSelect
      parameterDescription={parameterDescriptionWithValues}
      getValueDisplayName={getValueDisplayName}
      value={value}
      {...rest}
    />
  );
};
